import React from "react";
import {
  FirstGrouping,
  Media,
  SecondGrouping,
  ThirdGrouping,
} from "../../types/media";
import { useTranslation } from "@coworker/locales";
import {
  FixaOption,
  FixaSelect,
} from "@coworker/apprestructured/src/shared/wrappers/FixaSelect/FixaSelect";
import StairsIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/StairsIconPath";

interface ThirdGroupingSelectProps {
  media: Media;
  onSave: (newMedia: Media) => void;
  availableGroupingOptions: string[];
}

export const ThirdGroupingSelect = ({
  media,
  onSave,
  availableGroupingOptions,
}: ThirdGroupingSelectProps) => {
  const { t } = useTranslation();
  return (
    <FixaSelect
      id={"thirdGrouping"}
      label={t("thirdGroupingString")}
      value={(media as ThirdGrouping).thirdGrouping ?? ""}
      ssrIcon={StairsIconPath}
      onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
        const newGrouping =
          event.target.selectedIndex === 0 ? "" : event.target.value;
        const newMedia = { ...media };

        const oldGrouping = (newMedia as ThirdGrouping).thirdGrouping;
        (newMedia as ThirdGrouping).thirdGrouping = newGrouping;

        if ((newMedia as FirstGrouping).firstGrouping === newGrouping) {
          (newMedia as FirstGrouping).firstGrouping = oldGrouping;
        }
        if ((newMedia as SecondGrouping).secondGrouping === newGrouping) {
          (newMedia as SecondGrouping).secondGrouping = oldGrouping;
        }
        onSave(newMedia);
      }}
    >
      {availableGroupingOptions.map((grouping) => (
        <FixaOption {...{ value: grouping, name: grouping }} key={grouping} />
      ))}
    </FixaSelect>
  );
};
